import {
     Directive,
     ElementRef,
     EventEmitter,
     HostListener,
     Input,
     OnDestroy,
     OnInit,
     Output,
} from '@angular/core';
import * as j from 'jquery';
import { InteractionService } from '../services/interaction.service';

const jQuery = window.jQuery || j;

// @ts-ignore
@Directive({
     selector: '[bvKeyboard]',
})
export class KeyboardDirective implements /*OnChanges,*/ OnDestroy, OnInit {
     @Input('bvKeyboard') bvKeyboard: any;
     @Input('bvKeyboardAutocomplete') bvKeyboardAutocomplete: any;
     @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

     $el: any;
     keyboardDefaultSettings = {
          openOn: null,
          layout: 'ms-French',
          position: {},
          css: {
               // input & preview
               /*input: 'keyboard-input',
      // keyboard container
      container: 'keyboard-container', // jumbotron
      // default state
      buttonDefault: 'keyboard-btn keyboard-btn-default',
      // hovered button
      buttonHover: 'keyboard-btn-hover',
      // Action keys (e.g. Accept, Cancel, Tab, etc);
      // this replaces "actionClass" option
      buttonAction: 'active',
      // used when disabling the decimal button {dec}
      // when a decimal exists in the input area
      buttonDisabled: 'disabled'*/
               // used when "usePreview" is false
               // (centers keyboard at bottom of the input/textarea)
               at2: 'center bottom',
          },
          // lockInput: false,
          hidden: (event, keyboard, el) => {
               try {
                    keyboard.destroy();
               } catch (e) {}
          },
     };

     constructor(
          private el: ElementRef,
          private interactionMonitor: InteractionService
     ) {
          this.$el = jQuery(this.el.nativeElement);
     }

     // tip from https://embed.plnkr.co/?show=preview
     @HostListener('click')
     onClick() {
          this.openKeyboard();
     }

     hiddenHandler() {
          const keyboard = this.$el.getkeyboard();
          // this.model.valueAccessor.writeValue(this.$el.val());
          this.ngModelChange.emit(this.$el.val());

          if (keyboard) {
               try {
                    keyboard.destroy();
               } catch (e) {}
          }
     }

     // https://github.com/Mottie/Keyboard/wiki/Extension-Autocomplete
     openKeyboard() {
          let keyboard = this.$el.getkeyboard ? this.$el.getkeyboard() : false;
          const _that = this;
          if (!keyboard) {
               const options: any = {
                    initialFocus: true,
                    position: {
                         // of: null,
                         my2: 'center center',
                    },
                    // Methods: https://github.com/Mottie/Keyboard/wiki/Options#methods-callback-options
                    hidden: () => {
                         this.hiddenHandler();
                         console.log('---------------------------------');
                         console.log('keyboard.hidden');
                         console.log('---------------------------------');
                         try {
                              keyboard.destroy();
                         } catch (err) {}
                         // _that.borneState.virtualKeyboardOpen = false;
                    },
                    accepted: function (event, _keyboard, el) {
                         console.log('---------------------------------');
                         console.log('keyboard.accepted');
                         console.log('---------------------------------');
                         if (_that.bvKeyboard.onAccept) {
                              _that.bvKeyboard.onAccept(event, _keyboard, el);
                         }
                    },
                    change: (event, theKeyboard, el) => {
                         console.log(`[keyboard][change] `, {
                              event,
                              theKeyboard,
                              el,
                         });
                         _that.interactionMonitor.reset();
                         if (this.bvKeyboard && this.bvKeyboard.onKeyUp) {
                              this.bvKeyboard.onKeyUp(
                                   event,
                                   this.$el.getkeyboard()
                              );
                         }
                    },
                    visible: function (e, kb, el) {
                         // Simple hack to automatically position the caret at the end of the text field
                         if (kb.$preview.caret().start === 0) {
                              const v = kb.getValue().length;
                              kb.$preview.caret(v, v);
                         }
                    },
               };
               if (this.bvKeyboard && this.bvKeyboard.layout) {
                    options.layout =
                         (this.bvKeyboard && this.bvKeyboard.layout) || void 0;
               }
               this.$el.keyboard(
                    Object.assign(<any>this.keyboardDefaultSettings, options)
               );
               keyboard = this.$el.getkeyboard();
          }
          // this.borneState.virtualKeyboardOpen = true;
          keyboard.reveal();
     }

     ngOnDestroy() {
          this.hiddenHandler();
     }

     ngOnInit() {}
}

/*
 https://mottie.github.io/Keyboard/docs/layouts.html
French (azerty-1)
 */
